<header class="topbar">
  <div class="container py-3 d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <img *ngIf="logo" class="brand-logo" [src]="logo" alt="Logo do empregador">
      <span *ngIf="!logo" class="brand-mark">{{ iniciais }}</span>
      <div>
        <h1 class="h4 mb-0">{{ nome }}</h1>
        <span class="text-secondary small">{{ subtitulo }}</span>
      </div>
    </div>
    <div class="text-end">
      <div class="fw-semibold">{{ agora | date:'dd/MM/yyyy' }}</div>
      <div class="text-secondary">{{ agora | date:'HH:mm:ss' }}</div>
    </div>
  </div>
</header>
